import { type DataProvider as RaDataProvider, fetchUtils } from 'react-admin'
import simpleRestProvider from 'ra-data-simple-rest'
import { isNil } from 'lodash/fp'

import {
  getAnnounces,
  getCustomHeaders,
  getUserReserve,
  url
} from './functions'
import { type AnnounceItem } from '../../../../cdk/bapp/lib/lambda-api/src/types'

const fetchJson =
  (partner: string | undefined) =>
  (url: string, options: fetchUtils.Options = {}): any => {
    const customHeaders = getCustomHeaders(options, partner)
    if (isNil(customHeaders)) return undefined
    options.headers = customHeaders
    return fetchUtils.fetchJson(url, options)
  }

export const DataProvider = (partner: string | undefined): RaDataProvider => ({
  ...simpleRestProvider(url as string, fetchJson(partner)),
  getAnnounces: async (partner: string): Promise<AnnounceItem[] | undefined> =>
    await getAnnounces(),
  getUserReserve: async (
    partner: string,
    id: string
  ): Promise<{
    data: { data: any; date: string } | undefined
    status: number
  }> => await getUserReserve(partner, id)
})
